"use strict";
/** state: Final **/
/** family: FileUploader **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Button_1 = require("../Button");
var CLASS_NAME = 'i-file-uploader__button';
/**
 * This component provides a way for users to open a file selection dialogue.
 * Users relying on screen-readers will instead be able to tab to the more semantic
 * <input type="file" /> component rendered by {{FileUploader#FileUploader}}.
 */
var FileUploadButton = function (_a) {
    var children = _a.children, openFileDialog = _a.openFileDialog, className = _a.className, restProps = __rest(_a, ["children", "openFileDialog", "className"]);
    return (React.createElement(Button_1.Button, __assign({ "aria-hidden": true, className: classNames(CLASS_NAME, className), label: "", mode: Button_1.Button.Mode.Secondary, onClick: openFileDialog }, restProps), children));
};
exports.FileUploadButton = FileUploadButton;
//# sourceMappingURL=FileUploadButton.js.map